import { submitEmployeeWithholdings } from 'api';
import { postJSON } from 'api/fetch';

import { formatEmployeeWithholdingPayload } from 'features/team/util';

import * as flashNotice from 'util/flashNotice';
import { toI18n } from 'util/i18n';

import { I18N_TAX_FORMS_PATH } from '../constants';

export default (formName, formData, values) => {
  const form = formData.employee_forms.find(f => f.description === formName);
  const formId = form.id;

  const parameters = formatEmployeeWithholdingPayload(values, form.parameters);

  return postJSON(submitEmployeeWithholdings(formData.id), {
    form_id: formId,
    parameters,
  }).catch(() => {
    flashNotice.error(
      toI18n(`${I18N_TAX_FORMS_PATH}.submit_withholding_failed`)
    );
  });
};
